<form [formGroup]="form" *ngIf="config && form">

  <div class="form-group">
    <label class="bmd-label-floating" for="category">
      Category
    </label>
    <input
      type="text"
      class="form-control"
      formControlName="category"
      name="category"
    />
  </div>

  <div class="form-group">
    <label class="bmd-label-floating" for="officeCode">
      Office Code
    </label>
    <input
      type="text"
      class="form-control"
      formControlName="officeCode"
      name="officeCode"
    />
  </div>

  <div class="form-group">
    <label class="bmd-label-floating" for="customerCode">
      Customer Code
    </label>
    <input
      type="text"
      class="form-control"
      formControlName="customerCode"
      name="customerCode"
    />
  </div>

  <div class="form-group">
    <label class="bmd-label-floating" for="tokenSalt">
      Token Salt
    </label>
    <input
      type="text"
      class="form-control"
      formControlName="tokenSalt"
      name="tokenSalt"
    />
  </div>

   <div class="form-group">
  <label class="bmd-label-floating" for="url">
    Payment URL
  </label>
  <input
    type="text"
    class="form-control"
    formControlName="url"
    name="url"
    placeholder="https://example.com/permit.html"
  />
</div>

</form>